/**
 * @file Purchase album related actions.
 */

import getLogger from '../util/logger';
import { getErrorString } from '../util/normalize-errors';

const log = getLogger('PurchaseAlbumAction');

export const SELECT_IDENTITY_FOR_PURCHASE =
  'purchase-album/SELECT_IDENTITY_FOR_PURCHASE';
export const DESELECT_IDENTITY_FOR_PURCHASE =
  'purchase-album/DESELECT_IDENTITY_FOR_PURCHASE';
export const SELECT_IDENTITY_FOR_JOIN =
  'purchase-album/SELECT_IDENTITY_FOR_JOIN';
export const DESELECT_IDENTITY_FOR_JOIN =
  'purchase-album/DESELECT_IDENTITY_FOR_JOIN';
export const CHECKOUT_REQUEST = 'purchase-album/CHECKOUT_REQUEST';
export const CHECKOUT_SUCCESS = 'purchase-album/CHECKOUT_SUCCESS';
export const CHECKOUT_FAILURE = 'purchase-album/CHECKOUT_FAILURE';

export const selectIdentityForPurchase = identity => {
  return { type: SELECT_IDENTITY_FOR_PURCHASE, identity };
};

export const deselectIdentityForPurchase = identity => {
  return { type: DESELECT_IDENTITY_FOR_PURCHASE, identity };
};

export const selectIdentityForJoin = identity => {
  return { type: SELECT_IDENTITY_FOR_JOIN, identity };
};

export const deselectIdentityForJoin = identity => {
  return { type: DESELECT_IDENTITY_FOR_JOIN, identity };
};

const checkoutRequest = () => {
  return { type: CHECKOUT_REQUEST };
};

const checkoutSuccess = purchasedUrl => {
  return { type: CHECKOUT_SUCCESS, purchasedUrl };
};

const checkoutFailure = error => {
  return { type: CHECKOUT_FAILURE, error };
};

export const checkout = async ({
  accountId,
  email,
  stripeToken,
  joinItems,
  purchaseItems,
  dispatch,
  checkoutMutation,
  albumJoinByCodeMutation,
}) => {
  log.info('checkout() :: Purchasing purchaseItems...', purchaseItems);
  log.info('checkout() :: Joining items...', joinItems);

  dispatch(checkoutRequest());

  try {
    if (joinItems.length > 0) {
      // No particular error gotten from this response, so we'll just await
      // as catch will get anything else. Perform this first, so that we
      // avoid failing at payment
      await albumJoinByCodeMutation(accountId, joinItems);
    }

    if (purchaseItems.length > 0) {
      const purchaseRes = await checkoutMutation(
        accountId,
        email,
        stripeToken,
        purchaseItems,
      );

      if (purchaseRes.data.checkout.is_paid) {
        dispatch(checkoutSuccess(purchaseRes.data.checkout.purchased_url));

        log.info('checkout() :: Checkout success');
      } else {
        const errorMessage = purchaseRes.data.checkout.errors.join('. ');

        dispatch(checkoutFailure(getErrorString(errorMessage)));

        log.error('checkout() :: Error:', errorMessage);
      }
    } else {
      dispatch(checkoutSuccess());
    }
  } catch (error) {
    log.error('checkout() :: Error:', error);

    dispatch(checkoutFailure(getErrorString(error)));
  }
};
